"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JUSTIFY_CONTENT = exports.ALIGN_ITEMS = void 0;
const ALIGN_ITEMS = {
  flexStart: 'flex-start',
  center: 'center',
  flexEnd: 'flex-end',
  stretch: 'stretch',
  baseline: 'baseline'
};
exports.ALIGN_ITEMS = ALIGN_ITEMS;
const JUSTIFY_CONTENT = {
  flexStart: 'flex-start',
  center: 'center',
  flexEnd: 'flex-end',
  spaceBetween: 'space-between',
  spaceAround: 'space-around',
  spaceEvenly: 'space-evenly'
};
exports.JUSTIFY_CONTENT = JUSTIFY_CONTENT;